const state = {
  content: {},
  options: {},
  selectedTab: "patientOverview",
  tabs: [
    {
      label: "Patient Overview",
      page: "patientOverview",
    },
    {
      label: "Assessment Diagnosis",
      page: "assessmentOverview",
    },
    {
      label: "Evaluation Download",
      page: "evaluationDownload",
    },
  ],
  loading: false,
};

export default state;
